
<template>
    <div class="content_article_container">
        <div class="video_container"> 
      <video class="video_player" loop autoplay muted>
        <source :src="mediaPath" type="video/mp4">
      </video>
    </div>
      <article class="content_article">
        <div class="article">
        <img class="back_icon" src="@/assets/img/contentLibrary/back_icon_1.png" @click="handleBack"/>
        <h2 class="article_title">{{ item.title }}</h2>
        <div class="article_text" v-html="item.text"></div>
    </div>
        </article>  
    </div>
    </template>
    
    <script>
    export default {
        name: 'ContentArticle',
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                
            }
        },
        mounted() {
            console.log("Content Article Item:", this.item);
           // app.api.Utils.muteAudioManager();
        },
        unmounted() {
           // app.api.Utils.unmuteAudioManager();
        },
        methods: {
          handleBack() {
              this.$emit('close-component');
          }
        },
        computed: {
            mediaPath() {
              return app.api.Utils.getMediaPath(this.item.media.src);
            }
        }
    
    };
    </script>
    
    <style lang="scss" scoped>
    .content_article_container {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .article {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 350px;
        height: 650px;
    }
    .article_title {
    margin-top: 65px;  
    text-align: left;    
    font-size: 30px;    
    font-family: 'Arla Strong';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    color: var(--md-black);
    }
    .article_text {
    margin-top: 30px;
    text-align: left;   
    font-size: 15px;    
    font-family: 'Arla Interface';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    
   
    }
    
 
    .back_icon {
        position: absolute;
        top: 0px;
        left: 0px;
        cursor: pointer;
    }  
    .video_container {
        position: absolute;
        width: 845px;
        height: 100%;
        overflow: hidden;
    }
    .content_article {
        position: absolute;
        right: 0;
        border-radius: 10px;
        width: 450px;
        background-color: var(--light-grey);
        height: 100%;
    }
    .video_player {
        border-radius: 10px 0 0 10px;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    
    </style>